import { AuditScreen } from "@/screens/control-panel/audit";

/** Thin wrapper — toda lógica fica em screens/control-panel/audit */
export function AuditPage() {
  return <AuditScreen />;
}
